<!-- Loading: no "knxDevices" frame yet -->
<ng-container *ngIf="!summary">
  <div class="row g-2 mb-3">
    <div class="col-6 col-sm-3" *ngFor="let _ of skeletonTiles">
      <div class="card h-100">
        <div class="card-body p-2 p-sm-3">
          <app-skeleton width="60%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:.4rem;"></app-skeleton>
          <app-skeleton width="45%" height="1.4rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- mobile view: list rows like the blind list -->
  <div *ngIf="listView.matches" class="card dash-list mb-3">
    <div class="dash-row" *ngFor="let _ of skeletonCards">
      <app-skeleton width="24px" height="34px" radius="3px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
      <div class="dash-row-main">
        <app-skeleton width="45%" height=".9rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:.3rem;"></app-skeleton>
        <app-skeleton width="30%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
      </div>
      <app-skeleton width="2.6rem" height="1.6rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
    </div>
  </div>
  <div *ngIf="!listView.matches" class="row g-2 mb-3">
    <div class="col-4 col-sm-3 col-lg-2" *ngFor="let _ of skeletonCards">
      <div class="card">
        <div class="card-body p-2 d-flex flex-column align-items-center">
          <app-skeleton width="70%" height="96px" radius="3px" [darkMode]="darkMode" style="display:block;width:70%;margin-bottom:.5rem;"></app-skeleton>
          <app-skeleton width="80%" height=".75rem" radius="4px" [darkMode]="darkMode" style="display:block;width:80%;margin-bottom:.3rem;"></app-skeleton>
          <app-skeleton width="50%" height=".9rem" radius="4px" [darkMode]="darkMode" style="display:block;width:50%;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="summary as s">

  <div class="dash-section-head">
    <div class="dash-section-title">
      <span class="badge bg-danger dash-live"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
      <span class="dash-section-name">🪟 {{ 'KNX_TAB_BLINDS' | translate }}</span>
      <span *ngIf="updatedAt" class="dash-section-age">· {{ 'UPDATED_AGO' | translate:{time: updatedAgo(updatedAt)} }}</span>
    </div>
  </div>

  <div *ngIf="!s.total" class="card mb-3">
    <div class="card-body p-3 text-muted small">{{ 'KNX_NO_DEVICES' | translate }}</div>
  </div>

  <ng-container *ngIf="s.total">

    <!-- a) Summary tiles: 2 × 2 on phones, one row of 4 from 576 px -->
    <div class="row g-2 mb-3 knx-btiles" [class.section-flash]="flash">
      <div class="col-6 col-sm-3">
        <div class="card h-100">
          <div class="card-body p-2 p-sm-3">
            <div class="knx-tile-label">{{ 'KNX_BLIND_AVG' | translate }}</div>
            <div class="knx-tile-value"><ng-container *ngIf="s.avgPos != null; else dash">{{ s.avgPos }}&nbsp;%</ng-container></div>
            <div class="knx-tile-sub knx-btile-scale">{{ 'KNX_BLIND_SCALE' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card h-100">
          <div class="card-body p-2 p-sm-3">
            <div class="knx-tile-label"><i class="knx-mini"></i>{{ 'KNX_BLINDS_OPEN' | translate }}</div>
            <div class="knx-tile-value">{{ s.open }}<span class="knx-tile-sub fw-normal"> / {{ s.total }}</span></div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card h-100">
          <div class="card-body p-2 p-sm-3">
            <div class="knx-tile-label"><i class="knx-mini knx-mini-partial"></i>{{ 'KNX_BLINDS_PARTIAL' | translate }}</div>
            <div class="knx-tile-value">{{ s.partial }}<span class="knx-tile-sub fw-normal"> / {{ s.total }}</span></div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card h-100">
          <div class="card-body p-2 p-sm-3">
            <div class="knx-tile-label"><i class="knx-mini knx-mini-closed"></i>{{ 'KNX_BLINDS_CLOSED' | translate }}</div>
            <div class="knx-tile-value">{{ s.closed }}<span class="knx-tile-sub fw-normal"> / {{ s.total }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center gap-2 mb-2">
      <span class="knx-hint text-muted">🔒 {{ 'KNX_READ_ONLY' | translate }}</span>
    </div>

    <!-- b) Mobile view (< 768 px): one list row per blind (a small window closed down to its position, room, blind name, position) -->
    <div *ngIf="listView.matches" class="card dash-list mb-3" [class.section-flash]="flash">
      <ng-container *ngFor="let f of floors; trackBy: trackFloor">
        <div class="dash-list-group">{{ (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
        <div *ngFor="let b of f.items; trackBy: trackCard" class="dash-row">
          <div class="knx-win knx-win-xs" [class.knx-win-unknown]="b.position == null" aria-hidden="true">
            <div class="knx-win-box"></div>
            <div class="knx-win-frame">
              <div class="knx-win-glass">
                <div class="knx-win-shutter" [style.height.%]="b.position ?? 0"></div>
              </div>
            </div>
            <div class="knx-win-sill"></div>
          </div>
          <div class="dash-row-main">
            <div class="dash-row-title">{{ (b.room | knxName:lang:'room') ?? (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
            <div class="dash-row-sub">{{ b.name | knxName:lang:'device' }}<ng-container *ngIf="b.since"> · <span class="text-nowrap" [title]="b.sinceFull">{{ 'KNX_SINCE' | translate:{time: b.since} }}</span></ng-container></div>
          </div>
          <div class="dash-row-end knx-bend">
            <span class="knx-blind-pct" [ngClass]="'knx-pct-' + b.state"><ng-container *ngIf="b.position != null; else dash">{{ b.position }}&nbsp;%</ng-container></span>
            <span class="knx-blind-state">{{ b.stateKey | translate }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- From 768 px: one window per blind, grouped by floor (rooms in HomeServer order) -->
    <div *ngIf="!listView.matches" class="mb-3">
      <ng-container *ngFor="let f of floors; trackBy: trackFloor">
        <div class="knx-bfloor">
        <div class="knx-floor fw-semibold text-uppercase text-muted mb-1">{{ (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
        <div class="row g-2 mb-2 knx-bgrid" [class.section-flash]="flash">
          <div class="col-4 col-sm-3 col-lg-2 knx-bcell" *ngFor="let b of f.items; trackBy: trackCard">
            <div class="card h-100 knx-bcard" [title]="(b.name | knxName:lang:'device') + ' · ' + ((b.room | knxName:lang:'room') ?? '') + (b.position != null ? ' · ' + b.position + ' %' : '')">
              <div class="card-body p-2 text-center">
                <div class="knx-win" [class.knx-win-unknown]="b.position == null" role="img"
                     [attr.aria-label]="(b.name | knxName:lang:'device') + ': ' + (b.position != null ? b.position + ' %, ' : '') + (b.stateKey | translate)">
                  <div class="knx-win-box"></div>
                  <div class="knx-win-frame">
                    <div class="knx-win-glass">
                      <div class="knx-win-shutter" [style.height.%]="b.position ?? 0"></div>
                    </div>
                  </div>
                  <div class="knx-win-sill"></div>
                </div>
                <div class="knx-blind-name text-truncate" [title]="b.name | knxName:lang:'device'">{{ b.name | knxName:lang:'device' }}</div>
                <div class="knx-blind-room text-truncate">{{ (b.room | knxName:lang:'room') ?? (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
                <div class="knx-blind-pos d-flex flex-wrap justify-content-center align-items-baseline">
                  <span class="knx-blind-pct" [ngClass]="'knx-pct-' + b.state"><ng-container *ngIf="b.position != null; else dash">{{ b.position }}&nbsp;%</ng-container></span>
                  <span class="knx-blind-state">{{ b.stateKey | translate }}</span>
                </div>
                <div *ngIf="b.since" class="knx-since text-truncate" [title]="b.sinceFull">{{ 'KNX_SINCE' | translate:{time: b.since} }}</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </ng-container>
    </div>

  </ng-container>
</ng-container>

<ng-template #dash>–</ng-template>
